import api from "../../../../api";

export function putUpdate(id, feedback) {
  return api.put(`v2/markEngagementDone/${id}`, feedback);
}
export function postFeedback(id, feedbackResponse) {
  return api.post(`engagement-feedback/${id}`, feedbackResponse);
}

export function postInterventionPrescription(id, prescription){
  return api.post(`intervention_feedback?caseId=${id}`, prescription);
}

export function getlastUnansweredMedicalSlot(engagement_id){
  return api.get(`/get-last-unanswered/${engagement_id}`);
}

export const getDoctorSlot = (caseId) => {
  return api.get(`v4/slots/doctor/${caseId}?is_rescheduling=true`);
}

export const bookDoctorSlot = (caseId, payload) =>{
  return api.put(`v4/reschedule-doctor-booking/${caseId}`, payload)
}

export const markAdhocCallDone = (caseId, payload) => {
  return api.put(`/markAdhocEngagementDone/${caseId}`, payload);
}